import React, { useState, useEffect } from "react";
import { NavLink, withRouter } from "react-router-dom";
import Button from "@material-ui/core/Button";
import { ApiUrl, Axios } from "../../../components";
import eventEmitter from "../../../util/emitter";

const {
  API_GET_USERS_APPROVALS,
  API_GET_NOTICES,
  API_GET_LOTS_LAWFIRM,
  GET_TOTAL_COUNT,
} = ApiUrl;

export default () => {
  const PERMISSIONS = JSON.parse(localStorage.getItem("permissions"));
  const [list, setList] = useState([]);
  const [notices, setNotices] = useState([]);
  const [pending, setPending] = useState([]);
  const [pendingData, setPendingData] = useState([]);
  const [mediationNotices, setMediationNotices] = useState([]);
  const [mediationList, setMediationList] = useState([]);
  const [totalCount, setTotalCount] = useState([]);
  const [totalAllCount, setTotalAllCount] = useState(0);
  const role = localStorage.getItem("role");
  const lawMediation = localStorage.getItem("lawMediation");

  const getTableRecords = async () => {
    Axios.Get(API_GET_USERS_APPROVALS + "respondent")
      .then((response) => {
        const resData = response.data;
        if (response.status == 200) {
          setList(resData?.data || []);
        } else {
          toast.error(resData.error);
        }
      })
      .catch((err) => {
        console.log(err, "wwwwwwwww");
      });
  };

  useEffect(() => {
    if (lawMediation === "false") {
      const getTableRecordsMediation = async () => {
        try {
          const response = await Axios.get(API_GET_USERS_APPROVALS + "respondent/mediation");
          const resData = response.data;
          if (response.status === 200) {
            setMediationList(resData?.data || []);
          } else {
            toast.error(resData.error);
          }
        } catch (err) {
          console.log(err, "wwwwwwwww");
        }
      };
      getTableRecordsMediation();
    }
  }, [lawMediation]);

  const getNotices = async () => {
    Axios.Get(API_GET_NOTICES)
      .then((response) => {
        const resData = response.data;
        if (response.status == 200) {
          setNotices(resData?.data || []);
          setTotalAllCount(resData.count);
        } else {
          toast.error(resData.error);
        }
      })
      .catch((err) => {
        console.log(err, "wwwwwwwww");
      });
  };

  const getPendingRecords = async () => {
    Axios.Get(API_GET_LOTS_LAWFIRM)
      .then((response) => {
        const resData = response.data;
        if (response.status == 200) {
          setPending(resData?.data || []);
        } else {
          toast.error(resData.error);
        }
      })
      .catch((err) => {
        console.log(err, "wwwwwwwww");
      });
  };

  useEffect(() => {
    if (lawMediation === "false") {
      const getPendingRecords1 = async () => {
        try {
          const response = await Axios.get(API_GET_LOTS_LAWFIRM + "/mediation");
          const resData = response.data;
          if (response.status === 200) {
            setPendingData(resData?.data || []);
          } else {
            toast.error(resData.error);
          }
        } catch (err) {
          console.log(err, "wwwwwwwww");
        }
      };
      getPendingRecords1();
    }
  }, [lawMediation]);

  useEffect(() => {
    if (lawMediation === "false") {
      const getNotices1 = async () => {
        try {
          const response = await Axios.get(API_GET_NOTICES + "/mediation");
          const resData = response.data;
          if (response.status === 200) {
            setMediationNotices(resData?.data || []);
          } else {
            toast.error(resData.error);
          }
        } catch (err) {
          console.log(err, "wwwwwwwww");
        }
      };
      getNotices1();
    }
  }, [lawMediation]);

  useEffect(() => {
    getTableRecords();
    getNotices();
    getPendingRecords();
  }, []);

  useEffect(() => {
    getTotalCount();
    eventEmitter.on("User_Approval_Status_Changed", getTotalCount);
    return () => {
      eventEmitter.off("User_Approval_Status_Changed", getTotalCount);
    };
  }, []);

  const getTotalCount = async () => {
    try {
      const { data, status } = await Axios.get(GET_TOTAL_COUNT);
      if (status === 200) {
        setTotalCount(data?.data || []);
      } else {
        console.error("Error:", data.error);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const getPendingApproval = (name) =>
    Number(totalCount.find((item) => item.name === name)?.admin_pending_approval_users) || 0;
  const advocatePendingApproval = getPendingApproval("Advocate");
  const arbitratorPendingApproval = getPendingApproval("Arbitrator");
  const totalPendingApprovals = advocatePendingApproval + arbitratorPendingApproval;

  return (
    <div className="mt-4">
      {role == "Superadmin" ? (
        <ul className="nav-menu">
          {/* dharmani */}
          <li>
            <NavLink to="/app/admin/dashboard">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
              <span className="nav-text">Dashboard</span>
            </NavLink>
          </li>
          <li className="menu collapse-box">
            <Button href="javascript:void(0)" className="cbutton">
              <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
              <span className="nav-text">Users</span>
            </Button>
            <ul className="sub-menu">
              <li>
                <NavLink className="prepend-icon cbutton" to="/app/users/list">
                  {/* <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" /> */}
                  <span className="nav-text">All</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  className="prepend-icon cbutton"
                  to="/app/users/approved"
                >
                  {/* <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" /> */}
                  <span className="nav-text">Approved</span>
                </NavLink>
              </li>
              <li>
                <NavLink className="prepend-icon cbutton" to="/app/users/new">
                  {/* <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" /> */}
                  <span className="nav-text">Pending</span>
                </NavLink>
              </li>
            </ul>
          </li>
          <li className="menu collapse-box">
            <Button href="javascript:void(0)" className="cbutton">
              <i className="zmdi zmdi-blur-circular" />
              <span className="nav-text">  Pending Appr.</span>
              <span className="approval-count">{totalPendingApprovals}</span>
            </Button>
            <ul className="sub-menu">
              <li>
                <NavLink
                  className="prepend-icon cbutton"
                  to="/app/arbit-approval/list"
                >
                  <span className="nav-text">Arbitrator</span>
                  <span className="approval-count">{arbitratorPendingApproval}</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  className="prepend-icon cbutton"
                  to="/app/advocate-approval/list"
                >
                  <span className="nav-text">Advocate</span>
                  <span className="approval-count">{advocatePendingApproval}</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  className="prepend-icon cbutton"
                  to="/app/claimant-approval/list"
                >
                  <span className="nav-text">Claimants</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  className="prepend-icon cbutton"
                  to="/app/respondent-approval/list"
                >
                  <span className="nav-text">Respondent</span>
                </NavLink>
              </li>
            </ul>
          </li>

          {/* <li>
            <NavLink to="/app/role/list">
              <i className="zmdi zmdi-dot-circle zmdi-hc-fw" />
              <span className="nav-text">Roles </span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/app/permission/list">
              <i className="zmdi zmdi-dot-circle zmdi-hc-fw" />
              <span className="nav-text">Permissions </span>
            </NavLink>
          </li> */}
          {/* dharmani */}

          <li>
            <NavLink to="/app/admin/all/clients/list">
              <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
              <span className="nav-text">Clients List</span>
            </NavLink>
          </li>

          {/* <li>
            <NavLink to="/app/admin/venue-bookings">
              <i className="zmdi zmdi-calendar"/>
              <span className="nav-text"> Venue Bookings</span>
            </NavLink>
          </li> */}

          <li className="menu collapse-box">
            <Button href="javascript:void(0)" className="cbutton">
              <i className="zmdi zmdi-folder zmdi-hc-fw" />
              <span className="nav-text">Lot Cases</span>
            </Button>
            <ul className="sub-menu">
              <li>
                <NavLink
                  className="prepend-icon cbutton"
                  to="/app/admin/all/approved/lots"
                >
                  <span className="nav-text">Approved Cases</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  className="prepend-icon cbutton"
                  to="/app/admin/all/pending/lots"
                >
                  <span className="nav-text">Pending Cases</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  className="prepend-icon cbutton"
                  to="/app/admin/all/lot-cases/trash"
                >
                  <span className="nav-text">Trash</span>
                </NavLink>
              </li>
            </ul>
          </li>

          {/* <li className="menu collapse-box">
            <Button href="javascript:void(0)" className="cbutton">
              <i className="zmdi zmdi-cloud-upload" />
              <span className="nav-text">User Approvals</span>
            </Button>
            <ul className="sub-menu">
              <li>
                <NavLink
                  className="prepend-icon cbutton"
                  to="/app/admin/users-approval/advocates"
                >
                  <span className="nav-text">Advocate</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  className="prepend-icon cbutton"
                  to="/app/admin/users-approval/arbitrators"
                >
                  <span className="nav-text">Arbitrator</span>
                </NavLink>
              </li>
            </ul>
          </li> */}

          {/* <li className="menu collapse-box">
            <Button href="javascript:void(0)" className="cbutton">
              <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
              <span className="nav-text">Clients</span>
            </Button>
            <ul className="sub-menu">
              <li>
                <NavLink
                  className="prepend-icon cbutton"
                  to="/app/admin/all/approved/clients"
                >
                  <span className="nav-text">Approved</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  className="prepend-icon cbutton"
                  to="/app/admin/all/pending/clients"
                >
                  <span className="nav-text">Pending</span>
                </NavLink>
              </li>
            </ul>
          </li> */}
          <li>
            <NavLink to="/app/admin/signature">
              <i className="zmdi zmdi-border-color" />
              <span className="nav-text">Sign Digitally</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/app/activity">
              <i className="zmdi zmdi-delicious zmdi-hc-fw" />
              <span className="nav-text">Activity Log</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/app/troubleshoot">
              <i className="zmdi zmdi-arrows zmdi-hc-fw" />
              <span className="nav-text">Troubleshoot</span>
            </NavLink>
          </li>
          <li className="menu collapse-box">
            <Button href="javascript:void(0)" className="cbutton">
              <i className="zmdi zmdi-settings zmdi-hc-fw" />
              <span className="nav-text">Settings</span>
            </Button>
            <ul className="sub-menu">
              {/* dharmani */}
              <li>
                <NavLink to="/app/admin/manage/utilities">
                  <span className="nav-text">Utility Settings</span>
                </NavLink>
              </li>
              {/* <li>
                <NavLink to="/app/admin/manage/payment-settings">
                  <span className="nav-text">Payment Settings</span>
                </NavLink>
              </li> */}
              <li>
                <NavLink to="/app/settings">
                  <span className="nav-text">App Settings</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/app/admin/general">
                  <span className="nav-text">General Settings </span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/app/profile/add">
                  {/* <i className="zmdi zmdi-settings zmdi-hc-fw" /> */}
                  <span className="nav-text">Profile Settings</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/app/notification">
                  {/* <i className="zmdi zmdi-notifications-active zmdi-hc-fw" /> */}
                  <span className="nav-text">Push Notification</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  className="prepend-icon cbutton"
                  to="/app/settings/sms"
                >
                  {/* <i class="zmdi zmdi-comment-text"></i> */}
                  <span className="nav-text">SMS Templates</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/app/email/add">
                  {/* <i className="zmdi zmdi-email-open" /> */}
                  <span className="nav-text">Email Settings</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/app/cache/add">
                  {/* <i className="zmdi zmdi-collection-speaker" /> */}
                  <span className="nav-text">System</span>
                </NavLink>
              </li>
            </ul>
          </li>
          <li className="menu collapse-box">
            <Button href="javascript:void(0)" className="cbutton">
              <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
              <span className="nav-text">Mediation</span>
            </Button>
            <ul className="sub-menu">
              <li className="menu collapse-box">
                <Button href="javascript:void(0)" className="cbutton">
                  <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
                  <span className="nav-text">Case Manager</span>
                </Button>
                <ul className="sub-menu">
                  <li>
                    <NavLink
                      className="prepend-icon cbutton"
                      to="/app/admin/assign-case"
                    >
                      {/* <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" /> */}
                      <span className="nav-text">Assign Case</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className="prepend-icon cbutton"
                      to="/app/admin/assign-manager"
                    >
                      {/* <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" /> */}
                      <span className="nav-text">Assign Manager</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className="prepend-icon cbutton"
                      to="/app/admin/reassign-manager"
                    >
                      {/* <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" /> */}
                      <span className="nav-text">Re-Assign</span>
                    </NavLink>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <NavLink to="/app/admin/message-us">
              <i className="zmdi zmdi-email" />
              <span className="nav-text">  Message Us</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/app/client/trash/documents">
              <i className="zmdi zmdi-delete" />
              <span className="nav-text">Trash</span>
            </NavLink>
          </li>
        </ul>
      ) : role == "Arbitrator" ? (
        <ul className="nav-menu">
          <li>
            <NavLink to="/app/arbitrator/dashboard/index">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
              <span className="nav-text">Dashboard</span>
            </NavLink>
          </li>
          {PERMISSIONS && PERMISSIONS.includes("profile_settings") && (
            <li>
              <NavLink to="/app/arbitrator/profile/add">
                <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
                <span className="nav-text">Profile Settings </span>
              </NavLink>
            </li>
          )}
          {PERMISSIONS && PERMISSIONS.includes("change_password") && (
            <li>
              <NavLink to="/app/arbitrator/change-password/add">
                <i className="zmdi zmdi-settings zmdi-hc-fw" />
                <span className="nav-text">Change Password </span>
              </NavLink>
            </li>
          )}
          {PERMISSIONS && PERMISSIONS.includes("arbitration_cases") && (
            <li className="menu collapse-box">
              <Button href="javascript:void(0)" className="cbutton">
                <i className="zmdi zmdi-dot-circle" />
                <span className="nav-text">Arbitration Cases</span>
              </Button>
              <ul className="sub-menu">
                {PERMISSIONS && PERMISSIONS.includes("add_bulk_cases") && (
                  <li>
                    <NavLink
                      className="prepend-icon cbutton"
                      to="/app/arbitrator/list"

                    >
                      {/* <i className="zmdi zmdi-dot-circle" /> */}
                      <span className="nav-text">Bulk Cases</span>
                    </NavLink>
                  </li>
                )}
                {PERMISSIONS && PERMISSIONS.includes("single_cases") && (
                  <li>
                    <NavLink
                      className="prepend-icon cbutton"
                      to="/app/arbitrator/new"

                    >
                      {/* <i className="zmdi zmdi-dot-circle" /> */}
                      <span className="nav-text">Single Cases </span>
                    </NavLink>
                  </li>
                )}
                {/* <li>
                <NavLink
                  className="prepend-icon cbutton"
                  to="/app/arbitrator/pending"
                >
                  <i className="zmdi zmdi-dot-circle" />
                  <span className="nav-text">Pending Cases </span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  className="prepend-icon cbutton"
                  to="/app/arbitrator/disposed"
                >
                  <i className="zmdi zmdi-dot-circle" />
                  <span className="nav-text">Disposed Cases </span>
                </NavLink>
              </li> */}
              </ul>
            </li>
          )}
          {PERMISSIONS && PERMISSIONS.includes("sign_digitally") && (
            <li>
              <NavLink to="/app/lawfirm/signature">
                <i className="zmdi zmdi-border-color" />
                <span className="nav-text">Sign Digitally</span>
              </NavLink>
            </li>
          )}
          {PERMISSIONS && PERMISSIONS.includes("join_meeting") && (
            <li>
              <NavLink to="/app/party/join-meeting">
                <i className="zmdi zmdi-videocam" />
                <span className="nav-text">Join Meeting</span>
              </NavLink>
            </li>
          )}
          {PERMISSIONS && PERMISSIONS.includes("mediation") && (
            <li>
              <NavLink to="/app/mediation-process/list">
                <i className="zmdi zmdi-settings zmdi-hc-fw" />
                <span className="nav-text">Mediation </span>
              </NavLink>
            </li>
          )}
          {PERMISSIONS && PERMISSIONS.includes("conciliation") && (
            <li>
              <NavLink to="/app/arbitrator/conciliation/list">
                <i className="zmdi zmdi-settings zmdi-hc-fw" />
                <span className="nav-text">Conciliation </span>
              </NavLink>
            </li>
          )}
          {PERMISSIONS && PERMISSIONS.includes("bookings") && (
            <li>
              <NavLink to="/app/arbitrator/bookings/list">
                <i className="zmdi zmdi-settings zmdi-hc-fw" />
                <span className="nav-text">Bookings </span>
              </NavLink>
            </li>
          )}
        </ul>
      ) : role == "Mediator" ? (
        <ul className="nav-menu">
          <li>
            <NavLink to="/app/mediator/dashboard/index">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
              <span className="nav-text">Dashboard</span>
            </NavLink>
          </li>
          {PERMISSIONS && PERMISSIONS.includes("profile_settings") && (
            <li>
              <NavLink to="/app/arbitrator/profile/add">
                <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
                <span className="nav-text">Profile Settings</span>
              </NavLink>
            </li>
          )}
          {PERMISSIONS && PERMISSIONS.includes("change_password") && (
            <li>
              <NavLink to="/app/arbitrator/change-password/add">
                <i className="zmdi zmdi-settings zmdi-hc-fw" />
                <span className="nav-text">Change Password</span>
              </NavLink>
            </li>
          )}
          {PERMISSIONS && PERMISSIONS.includes("mediator_cases") && (
            <li className="menu collapse-box">
              <Button href="javascript:void(0)" className="cbutton">
                <i className="zmdi zmdi-dot-circle" />
                <span className="nav-text">Mediator Cases</span>
              </Button>
              <ul className="sub-menu">
                {PERMISSIONS && PERMISSIONS.includes("add_bulk_cases") && (
                  <li>
                    <NavLink
                      className="prepend-icon cbutton"
                      to="/app/mediator/list"
                    >
                      {/* <i className="zmdi zmdi-dot-circle" /> */}
                      <span className="nav-text">Bulk Cases</span>
                    </NavLink>
                  </li>
                )}
                {PERMISSIONS && PERMISSIONS.includes("single_cases") && (
                  <li>
                    <NavLink
                      className="prepend-icon cbutton"
                      to="/app/mediator/new"
                    >
                      {/* <i className="zmdi zmdi-dot-circle" /> */}
                      <span className="nav-text">Single Cases </span>
                    </NavLink>
                  </li>
                )}
                {/* <li>
                <NavLink
                  className="prepend-icon cbutton"
                  to="/app/arbitrator/pending"
                >
                  <i className="zmdi zmdi-dot-circle" />
                  <span className="nav-text">Pending Cases </span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  className="prepend-icon cbutton"
                  to="/app/arbitrator/disposed"
                >
                  <i className="zmdi zmdi-dot-circle" />
                  <span className="nav-text">Disposed Cases </span>
                </NavLink>
              </li> */}
              </ul>
            </li>
          )}
          {PERMISSIONS && PERMISSIONS.includes("sign_digitally") && (
            <li>
              <NavLink to="/app/lawfirm/signature">
                <i className="zmdi zmdi-border-color" />
                <span className="nav-text">Sign Digitally</span>
              </NavLink>
            </li>
          )}
          {PERMISSIONS && PERMISSIONS.includes("join_meeting") && (
            <li>
              <NavLink to="/app/party/join-meeting">
                <i className="zmdi zmdi-videocam" />
                <span className="nav-text">Join Meeting</span>
              </NavLink>
            </li>
          )}
          {/* <li>
            <NavLink to="/app/mediation-process/list">
              <i className="zmdi zmdi-settings zmdi-hc-fw" />
              <span className="nav-text">Mediation </span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/app/arbitrator/conciliation/list">
              <i className="zmdi zmdi-settings zmdi-hc-fw" />
              <span className="nav-text">Conciliation </span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/app/arbitrator/bookings/list">
              <i className="zmdi zmdi-settings zmdi-hc-fw" />
              <span className="nav-text">Bookings </span>
            </NavLink>
          </li> */}
        </ul>
      ) : role == "Advocate" ? (
        <ul className="nav-menu">
          <li>
            <NavLink to="/app/advocate/dashboard/index">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
              <span className="nav-text">Dashboard</span>
            </NavLink>
          </li>
          {PERMISSIONS && PERMISSIONS.includes("change_password") && (
            <li>
              <NavLink to="/app/advocate/change-password">
                <i className="zmdi zmdi-edit" />
                <span className="nav-text">Change Password</span>
              </NavLink>
            </li>
          )}
          {PERMISSIONS && PERMISSIONS.includes("join_meeting") && (
            <li>
              <NavLink to="/app/advocate/join-meeting">
                <i className="zmdi zmdi-videocam" />
                <span className="nav-text">Join Meeting</span>
              </NavLink>
            </li>
          )}
          {PERMISSIONS && PERMISSIONS.includes("arbitration_cases") && (
            <li className="menu collapse-box">
              <Button href="javascript:void(0)" className="cbutton">
                <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
                <span className="nav-text">Arbitration</span>
              </Button>
              <ul className="sub-menu">
                {/* <li>
                <NavLink
                  className="prepend-icon cbutton"
                  to="/app/advocate/register-case"
                >
                  <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
                  <span className="nav-text">File Fresh Case </span>
                </NavLink>
              </li> */}
                {PERMISSIONS && PERMISSIONS.includes("filed_cases") && (
                  <li>
                    <NavLink
                      className="prepend-icon cbutton"
                      to="/app/advocate/registered-cases"
                    >
                      {/* <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" /> */}
                      <span className="nav-text">Filed Cases </span>
                    </NavLink>
                  </li>
                )}
                {PERMISSIONS && PERMISSIONS.includes("respondent_cases") && (
                  <li>
                    <NavLink
                      className="prepend-icon cbutton"
                      to="/app/advocate/all-respondant-cases/"
                    >
                      {/* <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" /> */}
                      <span className="nav-text">Respondent Cases</span>
                    </NavLink>
                  </li>
                )}
              </ul>
            </li>
          )}
          {PERMISSIONS && PERMISSIONS.includes("mediation") && (
            <li className="menu collapse-box">
              <Button href="javascript:void(0)" className="cbutton">
                <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
                <span className="nav-text">Mediation</span>
              </Button>
              <ul className="sub-menu">
                {/* <li>
                <NavLink
                  className="prepend-icon cbutton"
                  to="/app/advocate/mediation/file/fresh-case"
                >
                  <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
                  <span className="nav-text">File Fresh Case </span>
                </NavLink>
              </li> */}
                {PERMISSIONS && PERMISSIONS.includes("filed_cases") && (
                  <li>
                    <NavLink
                      className="prepend-icon cbutton"
                      to="/app/advocate/mediation/filed-cases"
                    >
                      {/* <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" /> */}
                      <span className="nav-text">Filed Cases</span>
                    </NavLink>
                  </li>
                )}
                {PERMISSIONS && PERMISSIONS.includes("second_party_cases") && (
                  <li>
                    <NavLink
                      className="prepend-icon cbutton"
                      to="/app/advocate/mediation/second-party-cases"
                    >
                      {/* <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" /> */}
                      <span className="nav-text">Second Party Cases</span>
                    </NavLink>
                  </li>
                )}
              </ul>
            </li>
          )}
          {PERMISSIONS && PERMISSIONS.includes("conciliation") && (
            <li className="menu collapse-box">
              <Button href="javascript:void(0)" className="cbutton">
                <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
                <span className="nav-text">Conciliation</span>
              </Button>
              <ul className="sub-menu">
                {/* <li>
                <NavLink
                  className="prepend-icon cbutton"
                  to="/app/advocate/conciliation/file/fresh-case"
                >
                  <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
                  <span className="nav-text">File Fresh Case </span>
                </NavLink>
              </li> */}
                {PERMISSIONS && PERMISSIONS.includes("filed_cases") && (
                  <li>
                    <NavLink
                      className="prepend-icon cbutton"
                      to="/app/advocate/conciliation/filed-cases"
                    >
                      {/* <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" /> */}
                      <span className="nav-text">Filed Cases </span>
                    </NavLink>
                  </li>
                )}
                {PERMISSIONS && PERMISSIONS.includes("second_party_cases") && (
                  <li>
                    <NavLink
                      className="prepend-icon cbutton"
                      to="/app/advocate/conciliation/second-party-cases"
                    >
                      {/* <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" /> */}
                      <span className="nav-text">Second Party Cases </span>
                    </NavLink>
                  </li>
                )}
              </ul>
            </li>
          )}
          {PERMISSIONS && PERMISSIONS.includes("sign_digitally") && (
            <li>
              <NavLink to="/app/lawfirm/signature">
                <i className="zmdi zmdi-border-color" />
                <span className="nav-text">Sign Digitally</span>
              </NavLink>
            </li>
          )}
          {PERMISSIONS && PERMISSIONS.includes("bookings") && (
            <li>
              <NavLink to="/app/advocate/bookings">
                <i className="zmdi zmdi-settings zmdi-hc-fw" />
                <span className="nav-text">Bookings </span>
              </NavLink>
            </li>
          )}
          {PERMISSIONS && PERMISSIONS.includes("profile_settings") && (
            <li>
              <NavLink to="/app/advocate/change-password">
                <i className="zmdi zmdi-settings zmdi-hc-fw" />
                <span className="nav-text">Profile Settings </span>
              </NavLink>
            </li>
          )}
        </ul>
      ) : role == "Mediator" ? (
        <ul className="nav-menu">
          {/* <li>
            <NavLink to="/app/dashboard/index">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
              <span className="nav-text">Dashboard</span>
            </NavLink>
          </li> */}
          {PERMISSIONS && PERMISSIONS.includes("arbitration_cases") && (
            <li className="menu collapse-box">
              <Button href="javascript:void(0)" className="cbutton">
                <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
                <span className="nav-text">Arbitration Cases</span>
              </Button>
              <ul className="sub-menu">
                {PERMISSIONS && PERMISSIONS.includes("all_cases") && (
                  <li>
                    <NavLink className="prepend-icon cbutton" to="/app/users/list">
                      {/* <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" /> */}
                      <span className="nav-text">All Cases</span>
                    </NavLink>
                  </li>
                )}
                {PERMISSIONS && PERMISSIONS.includes("fresh_cases") && (
                  <li>
                    <NavLink
                      className="prepend-icon cbutton"
                      to="/app/users/approved"
                    >
                      {/* <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" /> */}
                      <span className="nav-text">Fresh Cases </span>
                    </NavLink>
                  </li>
                )}
                {PERMISSIONS && PERMISSIONS.includes("filed_cases") && (
                  <li>
                    <NavLink className="prepend-icon cbutton" to="/app/users/new">
                      {/* <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" /> */}
                      <span className="nav-text">Filed Cases </span>
                    </NavLink>
                  </li>
                )}
              </ul>
            </li>
          )}
          {PERMISSIONS && PERMISSIONS.includes("profile_settings") && (
            <li>
              <NavLink to="/app/profile/add">
                <i className="zmdi zmdi-settings zmdi-hc-fw" />
                <span className="nav-text">Profile Settings </span>
              </NavLink>
            </li>
          )}
        </ul>
      ) : role == "LawFirm" ? (
        lawMediation === "true" || lawMediation === null ? (
          <ul className="nav-menu">
            <li>
              <NavLink to="/app/lawfirm/dashboard/">
                <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
                <span className="nav-text">Dashboard</span>
              </NavLink>
            </li>
            {PERMISSIONS && PERMISSIONS.includes("clients_list") && (
              <li className="menu collapse-box">
                <Button href="javascript:void(0)" className="cbutton">
                  <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
                  <span className="nav-text">Clients</span>
                </Button>
                <ul className="sub-menu">
                  {PERMISSIONS && PERMISSIONS.includes("add_client") && (
                    <li>
                      <NavLink
                        className="prepend-icon cbutton"
                        to="/app/client/add"
                      >
                        {/* <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" /> */}
                        <span className="nav-text">Add Client </span>
                      </NavLink>
                    </li>
                  )}
                  {PERMISSIONS && PERMISSIONS.includes("clients_list") && (
                    <li>
                      <NavLink
                        className="prepend-icon cbutton"
                        to="/app/client/list"
                      >
                        {/* <i className="zmdi zmdi-file-text" /> */}
                        <span className="nav-text">Clients List</span>
                      </NavLink>
                    </li>
                  )}
                  {/* <li>
                <NavLink to="/app/template">
                  <i className="zmdi zmdi-assignment" />
                  <span className="nav-text">Templates </span>
                </NavLink>
              </li> */}
                </ul>
              </li>
            )}
            {PERMISSIONS && PERMISSIONS.includes("approvals") && (
              <li className="menu collapse-box">
                <Button href="javascript:void(0)" className="cbutton">
                  <i className="zmdi zmdi-file-text" />
                  <span className="nav-text">Approvals</span>
                  <span className="approval-count ml-4">
                    {pending?.length + totalAllCount}
                  </span>
                </Button>
                <ul className="sub-menu">
                  {PERMISSIONS && PERMISSIONS.includes("pending_cases") && (
                    <li>
                      <NavLink
                        className="prepend-icon cbutton"
                        to="/app/lawfirm/pending-cases/"
                      >
                        {/* <i className="zmdi zmdi-file-text" /> */}
                        <span className="nav-text">Pending Cases</span>
                        <span className="approval-count">{pending?.length}</span>
                      </NavLink>
                    </li>
                  )}
                  {PERMISSIONS && PERMISSIONS.includes("notices") && (
                    <li>
                      <NavLink
                        className="prepend-icon cbutton"
                        to="/app/lawfirm/notices/"
                      >
                        {/* <i className="zmdi zmdi-file-text" /> */}
                        <span className="nav-text">Notices</span>
                        <span className="approval-count">{totalAllCount}</span>
                      </NavLink>
                    </li>
                  )}
                </ul>
              </li>
            )}
            {PERMISSIONS && PERMISSIONS.includes("user_approval") && (
              <li>
                <NavLink to="/app/lawfirm/users-approval/">
                  <i className="zmdi zmdi-cloud-upload" />
                  <span className="nav-text">User Approval</span>
                  <span className="approval-count">{list?.length}</span>
                </NavLink>
              </li>
            )}
            {/* <li>
                <NavLink
                  className="prepend-icon cbutton"
                  to="/app/admin/users-approval/arbitrators"
                >
                  <i className="zmdi zmdi-balance" />
                  <span className="nav-text">Arbitrator Approval</span>
                </NavLink>
              </li> */}
            {/* <li className="menu collapse-box">
              <Button href="javascript:void(0)" className="cbutton">
                <i className="zmdi zmdi-balance" />
                <span className="nav-text">  Pending Appr.</span>
                <span className="approval-count">{totalPendingApprovals}</span>
              </Button>
              <ul className="sub-menu">
                <li>
                  <NavLink
                    className="prepend-icon cbutton"
                    to="/app/arbit-approval/list"
                  >
                    <span className="nav-text">Arbitrator</span>
                    <span className="approval-count">{arbitratorPendingApproval}</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    className="prepend-icon cbutton"
                    to="/app/advocate-approval/list"
                  >
                    <span className="nav-text">Advocate</span>
                    <span className="approval-count">{advocatePendingApproval}</span>
                  </NavLink>
                </li>
              </ul>
            </li> */}
            {PERMISSIONS && PERMISSIONS.includes("bulk_document") && (
              <li>
                <NavLink to="/app/lawfirm/documents">
                  <i className="zmdi zmdi-collection-text" />
                  <span className="nav-text">Bulk Document</span>
                </NavLink>
              </li>
            )}
            {PERMISSIONS && PERMISSIONS.includes("upload_shipments") && (
              <li>
                <NavLink to="/app/lawfirm/excel">
                  <i className="zmdi zmdi-cloud-upload" />
                  <span className="nav-text">Upload Shipments</span>
                </NavLink>
              </li>
            )}
            {PERMISSIONS && PERMISSIONS.includes("sign_digitally") && (
              <li>
                <NavLink to="/app/lawfirm/signature">
                  <i className="zmdi zmdi-border-color" />
                  <span className="nav-text">Sign Digitally</span>
                </NavLink>
              </li>
            )}
            {PERMISSIONS && PERMISSIONS.includes("update_cases") && (
              <li>
                <NavLink to="/app/lawfirm/update-cases">
                  <i className="zmdi zmdi-comment-edit" />
                  <span className="nav-text">Update Cases</span>
                </NavLink>
              </li>
            )}
            {PERMISSIONS && PERMISSIONS.includes("settings") && (
              <li className="menu collapse-box">
                <Button href="javascript:void(0)" className="cbutton">
                  <i className="zmdi zmdi-settings zmdi-hc-fw" />
                  <span className="nav-text">Settings</span>
                </Button>
                <ul className="sub-menu">
                  {PERMISSIONS && PERMISSIONS.includes("profile_settings") && (
                    <li>
                      <NavLink to="/app/lawfirm/profile">
                        <i className="zmdi zmdi-settings zmdi-hc-fw" />
                        <span className="nav-text">Profile Settings </span>
                      </NavLink>
                    </li>
                  )}
                  {PERMISSIONS && PERMISSIONS.includes("general_settings") && (
                    <li>
                      <NavLink to="/app/lawfirm/general">
                        <i className="zmdi zmdi-settings zmdi-hc-fw" />
                        <span className="nav-text">General Settings </span>
                      </NavLink>
                    </li>
                  )}
                </ul>
              </li>
            )}
            {PERMISSIONS && PERMISSIONS.includes("message_us") && (
              <li>
                <NavLink to="/app/lawfirm/message-us">
                  <i className="zmdi zmdi-email" />
                  <span className="nav-text">Message Us</span>
                </NavLink>
              </li>
            )}
          </ul>
        ) : (
          <ul className="nav-menu">
            <li>
              <NavLink to="/app/mediation/dashboard/">
                <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
                <span className="nav-text">Dashboard</span>
              </NavLink>
            </li>
            {PERMISSIONS && PERMISSIONS.includes("clients_list") && (
              <li className="menu collapse-box">
                <Button href="javascript:void(0)" className="cbutton">
                  <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
                  <span className="nav-text">Clients</span>
                </Button>
                <ul className="sub-menu">
                  {PERMISSIONS && PERMISSIONS.includes("add_client") && (
                    <li>
                      <NavLink
                        className="prepend-icon cbutton"
                        to="/app/mediation-client/add"
                      >
                        {/* <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" /> */}
                        <span className="nav-text">Add Client </span>
                      </NavLink>
                    </li>
                  )}
                  {PERMISSIONS && PERMISSIONS.includes("clients_list") && (
                    <li>
                      <NavLink
                        className="prepend-icon cbutton"
                        to="/app/mediation-client/list"
                      >
                        {/* <i className="zmdi zmdi-file-text" /> */}
                        <span className="nav-text">Clients List</span>
                      </NavLink>
                    </li>
                  )}
                  {/* <li>
                <NavLink to="/app/template">
                  <i className="zmdi zmdi-assignment" />
                  <span className="nav-text">Templates </span>
                </NavLink>
              </li> */}
                </ul>
              </li>
            )}
            {PERMISSIONS && PERMISSIONS.includes("approvals") && (
              <li className="menu collapse-box">
                <Button href="javascript:void(0)" className="cbutton">
                  <i className="zmdi zmdi-file-text" />
                  <span className="nav-text">Approvals</span>
                  <span className="approval-count ml-4">
                    {pendingData?.length + mediationNotices?.length}
                  </span>
                </Button>
                <ul className="sub-menu">
                  {PERMISSIONS && PERMISSIONS.includes("pending_cases") && (
                    <li>
                      <NavLink
                        className="prepend-icon cbutton"
                        to="/app/mediation/pending-cases/"
                      >
                        {/* <i className="zmdi zmdi-file-text" /> */}
                        <span className="nav-text">Pending Cases</span>
                        <span className="approval-count">{pendingData?.length}</span>
                      </NavLink>
                    </li>
                  )}
                  {PERMISSIONS && PERMISSIONS.includes("notices") && (
                    <li>
                      <NavLink
                        className="prepend-icon cbutton"
                        to="/app/mediation/notices/"
                      >
                        {/* <i className="zmdi zmdi-file-text" /> */}
                        <span className="nav-text">Notices</span>
                        <span className="approval-count">{mediationNotices?.length}</span>
                      </NavLink>
                    </li>
                  )}
                </ul>
              </li>
            )}
            {PERMISSIONS && PERMISSIONS.includes("user_approval") && (
              <li>
                <NavLink to="/app/mediation/users-approval/">
                  <i className="zmdi zmdi-cloud-upload" />
                  <span className="nav-text">User Approval</span>
                  <span className="approval-count">{mediationList?.length}</span>
                </NavLink>
              </li>
            )}
            {PERMISSIONS && PERMISSIONS.includes("bulk_document") && (
              <li>
                <NavLink to="/app/mediation/documents">
                  <i className="zmdi zmdi-collection-text" />
                  <span className="nav-text">Bulk Document</span>
                </NavLink>
              </li>
            )}
            {PERMISSIONS && PERMISSIONS.includes("sign_digitally") && (
              <li>
                <NavLink to="/app/mediation/signature">
                  <i className="zmdi zmdi-cloud-upload" />
                  <span className="nav-text">Sign Digitally</span>
                </NavLink>
              </li>
            )}
            {PERMISSIONS && PERMISSIONS.includes("update_cases") && (
              <li>
                <NavLink to="/app/mediation/update-cases">
                  <i className="zmdi zmdi-cloud-upload" />
                  <span className="nav-text">Update Cases</span>
                </NavLink>
              </li>
            )}
            {PERMISSIONS && PERMISSIONS.includes("join_meeting") && (
              <li>
                <NavLink to="/app/client/join-meeting">
                  <i className="zmdi zmdi-videocam" />
                  <span className="nav-text">Join Meeting</span>
                </NavLink>
              </li>
            )}
            {/* <li>
            <NavLink to="/app/mediation/users-approval/">
              <i className="zmdi zmdi-cloud-upload" />
              <span className="nav-text">User Approval</span>
            </NavLink>
          </li> */}
            {/* 
          <li>
            <NavLink to="/app/mediation/excel">
              <i className="zmdi zmdi-cloud-upload" />
              <span className="nav-text">Upload Shipments</span>
            </NavLink>
          </li>  
          <li>
            <NavLink to="/app/mediation/update-cases">
              <i className="zmdi zmdi-cloud-upload" />
              <span className="nav-text">Update Cases</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/app/mediation/profile">
              <i className="zmdi zmdi-settings zmdi-hc-fw" />
              <span className="nav-text">Profile Settings </span>
            </NavLink>
          </li> */}
          </ul>
        )
      ) : role == "Secretariat-L2" ? (
        <ul className="nav-menu">
          <li>
            <NavLink to="/app/lawfirm/dashboard/">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
              <span className="nav-text">Dashboard</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              className="prepend-icon cbutton"
              to="/app/client/list"
            >
              <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
              <span className="nav-text">Clients List</span>
            </NavLink>
          </li>
          <li className="menu collapse-box">
            <Button href="javascript:void(0)" className="cbutton">
              <i className="zmdi zmdi-file-text" />
              <span className="nav-text">Approvals</span>
              <span className="approval-count ml-4">
                {pending?.length + notices?.length}
              </span>
            </Button>
            <ul className="sub-menu">
              <li>
                <NavLink
                  className="prepend-icon cbutton"
                  to="/app/lawfirm/pending-cases/"
                >
                  <span className="nav-text">Pending Cases</span>
                  <span className="approval-count">{pending?.length}</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  className="prepend-icon cbutton"
                  to="/app/lawfirm/notices/"
                >
                  <span className="nav-text">Notices</span>
                  <span className="approval-count">{notices?.length}</span>
                </NavLink>
              </li>
            </ul>
          </li>
          <li>
            <NavLink to="/app/lawfirm/documents">
              <i className="zmdi zmdi-collection-text" />
              <span className="nav-text">Bulk Document</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/app/lawfirm/excel">
              <i className="zmdi zmdi-cloud-upload" />
              <span className="nav-text">Upload Shipments</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/app/lawfirm/update-cases">
              <i className="zmdi zmdi-comment-edit" />
              <span className="nav-text">Update Cases</span>
            </NavLink>
          </li>
          <li className="menu collapse-box">
            <Button href="javascript:void(0)" className="cbutton">
              <i className="zmdi zmdi-settings zmdi-hc-fw" />
              <span className="nav-text">Settings</span>
            </Button>
            <ul className="sub-menu">
              <li>
                <NavLink to="/app/lawfirm/profile">
                  <i className="zmdi zmdi-settings zmdi-hc-fw" />
                  <span className="nav-text">Profile Settings </span>
                </NavLink>
              </li>
            </ul>
          </li>
        </ul>
      ) : role == "Secretariat-L3" ? (
        <ul className="nav-menu">
          <li>
            <NavLink to="/app/lawfirm/dashboard/">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
              <span className="nav-text">Dashboard</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              className="prepend-icon cbutton"
              to="/app/client/list"
            >
              <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
              <span className="nav-text">Clients List</span>
            </NavLink>
          </li>
          <li className="menu collapse-box">
            <Button href="javascript:void(0)" className="cbutton">
              <i className="zmdi zmdi-file-text" />
              <span className="nav-text">Approvals</span>
              <span className="approval-count ml-4">
                {pending?.length + notices?.length}
              </span>
            </Button>
            <ul className="sub-menu">
              <li>
                <NavLink
                  className="prepend-icon cbutton"
                  to="/app/lawfirm/pending-cases/"
                >
                  <span className="nav-text">Pending Cases</span>
                  <span className="approval-count">{pending?.length}</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  className="prepend-icon cbutton"
                  to="/app/lawfirm/notices/"
                >
                  <span className="nav-text">Notices</span>
                  <span className="approval-count">{notices?.length}</span>
                </NavLink>
              </li>
            </ul>
          </li>
          <li>
            <NavLink to="/app/lawfirm/documents">
              <i className="zmdi zmdi-collection-text" />
              <span className="nav-text">Bulk Document</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/app/lawfirm/excel">
              <i className="zmdi zmdi-cloud-upload" />
              <span className="nav-text">Upload Shipments</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/app/lawfirm/update-cases">
              <i className="zmdi zmdi-comment-edit" />
              <span className="nav-text">Update Cases</span>
            </NavLink>
          </li>
          <li className="menu collapse-box">
            <Button href="javascript:void(0)" className="cbutton">
              <i className="zmdi zmdi-settings zmdi-hc-fw" />
              <span className="nav-text">Settings</span>
            </Button>
            <ul className="sub-menu">
              <li>
                <NavLink to="/app/lawfirm/profile">
                  <i className="zmdi zmdi-settings zmdi-hc-fw" />
                  <span className="nav-text">Profile Settings </span>
                </NavLink>
              </li>
            </ul>
          </li>
        </ul>
      ) : role == "Client" ? (
        <ul className="nav-menu">
          <li>
            <NavLink to="/app/client/dashboard/">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
              <span className="nav-text">Dashboard</span>
            </NavLink>
          </li>
          {PERMISSIONS && PERMISSIONS.includes("change_password") && (
            <li>
              <NavLink to="/app/client/password-updae">
                <i className="zmdi zmdi-edit" />
                <span className="nav-text">Change Password</span>
              </NavLink>
            </li>
          )}
          {PERMISSIONS && PERMISSIONS.includes("arbitration_cases") && (
            <li className="menu collapse-box">
              <Button href="javascript:void(0)" className="cbutton">
                <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
                <span className="nav-text">Arbitration</span>
              </Button>
              <ul className="sub-menu">
                {PERMISSIONS && PERMISSIONS.includes("all_cases") && (
                  <li>
                    <NavLink
                      className="prepend-icon cbutton"
                      to="/app/client/all/cases"
                    >
                      {/* <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" /> */}
                      <span className="nav-text">All Cases</span>
                    </NavLink>
                  </li>
                )}
                {PERMISSIONS && PERMISSIONS.includes("single_cases") && (
                  <li>
                    <NavLink
                      className="prepend-icon cbutton"
                      to="/app/clinet/single-case"
                    >
                      {/* <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" /> */}
                      <span className="nav-text">Single Cases </span>
                    </NavLink>
                  </li>
                )}
              </ul>
            </li>
          )}
          {PERMISSIONS && PERMISSIONS.includes("mediation") && (
            <li className="menu collapse-box">
              <Button href="javascript:void(0)" className="cbutton">
                <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
                <span className="nav-text">Mediation</span>
              </Button>
              <ul className="sub-menu">
                {/* <li>
                <NavLink
                  className="prepend-icon cbutton"
                  to="/app/client/mediation/file/fresh-case"
                >
                  <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
                  <span className="nav-text">File Fresh Case </span>
                </NavLink>
              </li> */}
                {PERMISSIONS && PERMISSIONS.includes("filed_cases") && (
                  <li>
                    <NavLink
                      className="prepend-icon cbutton"
                      to="/app/client/mediation/filed-cases"
                    >
                      {/* <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" /> */}
                      <span className="nav-text">Filed Cases </span>
                    </NavLink>
                  </li>
                )}
                {PERMISSIONS && PERMISSIONS.includes("second_party_cases") && (
                  <li>
                    <NavLink
                      className="prepend-icon cbutton"
                      to="/app/client/mediation/second-party-cases"
                    >
                      {/* <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" /> */}
                      <span className="nav-text">Second Party Cases </span>
                    </NavLink>
                  </li>
                )}
              </ul>
            </li>
          )}
          {PERMISSIONS && PERMISSIONS.includes("conciliation") && (
            <li className="menu collapse-box">
              <Button href="javascript:void(0)" className="cbutton">
                <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
                <span className="nav-text">Conciliation</span>
              </Button>
              <ul className="sub-menu">
                {/* <li>
                <NavLink
                  className="prepend-icon cbutton"
                  to="/app/clinet/conciliation/file/fresh-case"
                >
                  <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
                  <span className="nav-text">File Fresh Case </span>
                </NavLink>
              </li> */}
                {PERMISSIONS && PERMISSIONS.includes("filed_cases") && (
                  <li>
                    <NavLink
                      className="prepend-icon cbutton"
                      to="/app/client/conciliation/filed-cases"
                    >
                      {/* <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" /> */}
                      <span className="nav-text">Filed Cases </span>
                    </NavLink>
                  </li>
                )}
                {PERMISSIONS && PERMISSIONS.includes("second_party_cases") && (
                  <li>
                    <NavLink
                      className="prepend-icon cbutton"
                      to="/app/client/conciliation/second-party-cases"
                    >
                      {/* <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" /> */}
                      <span className="nav-text">Second Party Cases </span>
                    </NavLink>
                  </li>
                )}
              </ul>
            </li>
          )}
          {PERMISSIONS && PERMISSIONS.includes("sign_digitally") && (
            <li>
              <NavLink to="/app/lawfirm/signature">
                <i className="zmdi zmdi-border-color" />
                <span className="nav-text">Sign Digitally</span>
              </NavLink>
            </li>
          )}
          {PERMISSIONS && PERMISSIONS.includes("bookings") && (
            <li>
              <NavLink to="/app/client/booking">
                <i className="zmdi zmdi-settings zmdi-hc-fw" />
                <span className="nav-text">Bookings </span>
              </NavLink>
            </li>
          )}
          {PERMISSIONS && PERMISSIONS.includes("join_meeting") && (
            <li>
              <NavLink to="/app/client/join-meeting">
                <i className="zmdi zmdi-videocam" />
                <span className="nav-text">Join Meeting</span>
              </NavLink>
            </li>
          )}
          {PERMISSIONS && PERMISSIONS.includes("profile_settings") && (
            <li>
              <NavLink to="/app/client/password-updae">
                <i className="zmdi zmdi-settings zmdi-hc-fw" />
                <span className="nav-text">Profile Settings </span>
              </NavLink>
            </li>
          )}
        </ul>
      ) : role == "collection" ? (
        <ul className="nav-menu">
          <li>
            <NavLink to="/app/collection/dashboard/">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
              <span className="nav-text">Dashboard</span>
            </NavLink>
          </li>
          {PERMISSIONS && PERMISSIONS.includes("change_password") && (
            <li>
              <NavLink to="/app/collection/password-update">
                <i className="zmdi zmdi-edit" />
                <span className="nav-text">Change Password</span>
              </NavLink>
            </li>
          )}
          {PERMISSIONS && PERMISSIONS.includes("arbitration_cases") && (
            <li className="menu collapse-box">
              <Button href="javascript:void(0)" className="cbutton">
                <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
                <span className="nav-text">Arbitration</span>
              </Button>
              <ul className="sub-menu">
                {PERMISSIONS && PERMISSIONS.includes("all_cases") && (
                  <li>
                    <NavLink
                      className="prepend-icon cbutton"
                      to="/app/collection/all/cases"
                    >
                      {/* <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" /> */}
                      <span className="nav-text">All Cases</span>
                    </NavLink>
                  </li>
                )}
                {PERMISSIONS && PERMISSIONS.includes("single_cases") && (
                  <li>
                    <NavLink
                      className="prepend-icon cbutton"
                      to="/app/collection/single-case"
                    >
                      {/* <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" /> */}
                      <span className="nav-text">Single Cases </span>
                    </NavLink>
                  </li>
                )}
              </ul>
            </li>
          )}
          {PERMISSIONS && PERMISSIONS.includes("mediation") && (
            <li className="menu collapse-box">
              <Button href="javascript:void(0)" className="cbutton">
                <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
                <span className="nav-text">Mediation</span>
              </Button>
              <ul className="sub-menu">
                {/* <li>
                <NavLink
                  className="prepend-icon cbutton"
                  to="/app/client/mediation/file/fresh-case"
                >
                  <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
                  <span className="nav-text">File Fresh Case </span>
                </NavLink>
              </li> */}
                {PERMISSIONS && PERMISSIONS.includes("filed_cases") && (
                  <li>
                    <NavLink
                      className="prepend-icon cbutton"
                      to="/app/collection/mediation/filed-cases"
                    >
                      {/* <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" /> */}
                      <span className="nav-text">Filed Cases </span>
                    </NavLink>
                  </li>
                )}
                {PERMISSIONS && PERMISSIONS.includes("second_party_cases") && (
                  <li>
                    <NavLink
                      className="prepend-icon cbutton"
                      to="/app/collection/mediation/second-party-cases"
                    >
                      {/* <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" /> */}
                      <span className="nav-text">Second Party Cases </span>
                    </NavLink>
                  </li>
                )}
              </ul>
            </li>
          )}
          {PERMISSIONS && PERMISSIONS.includes("conciliation") && (
            <li className="menu collapse-box">
              <Button href="javascript:void(0)" className="cbutton">
                <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
                <span className="nav-text">Conciliation</span>
              </Button>
              <ul className="sub-menu">
                {/* <li>
                <NavLink
                  className="prepend-icon cbutton"
                  to="/app/clinet/conciliation/file/fresh-case"
                >
                  <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
                  <span className="nav-text">File Fresh Case </span>
                </NavLink>
              </li> */}
                {PERMISSIONS && PERMISSIONS.includes("filed_cases") && (
                  <li>
                    <NavLink
                      className="prepend-icon cbutton"
                      to="/app/collection/conciliation/filed-cases"
                    >
                      {/* <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" /> */}
                      <span className="nav-text">Filed Cases </span>
                    </NavLink>
                  </li>
                )}
                {PERMISSIONS && PERMISSIONS.includes("second_party_cases") && (
                  <li>
                    <NavLink
                      className="prepend-icon cbutton"
                      to="/app/collection/conciliation/second-party-cases"
                    >
                      {/* <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" /> */}
                      <span className="nav-text">Second Party Cases </span>
                    </NavLink>
                  </li>
                )}
              </ul>
            </li>
          )}
          {PERMISSIONS && PERMISSIONS.includes("sign_digitally") && (
            <li>
              <NavLink to="/app/lawfirm/signature">
                <i className="zmdi zmdi-border-color" />
                <span className="nav-text">Sign Digitally</span>
              </NavLink>
            </li>
          )}
          {PERMISSIONS && PERMISSIONS.includes("bookings") && (
            <li>
              <NavLink to="/app/collection/booking">
                <i className="zmdi zmdi-settings zmdi-hc-fw" />
                <span className="nav-text">Bookings </span>
              </NavLink>
            </li>
          )}
          {PERMISSIONS && PERMISSIONS.includes("join_meeting") && (
            <li>
              <NavLink to="/app/collection/join-meeting">
                <i className="zmdi zmdi-videocam" />
                <span className="nav-text">Join Meeting</span>
              </NavLink>
            </li>
          )}
          {PERMISSIONS && PERMISSIONS.includes("profile_settings") && (
            <li>
              <NavLink to="/app/collection/password-update">
                <i className="zmdi zmdi-settings zmdi-hc-fw" />
                <span className="nav-text">Profile Settings </span>
              </NavLink>
            </li>
          )}
        </ul>
      ) : role == "casemanager" ? (
        <ul className="nav-menu">
          <li>
            <NavLink to="/app/casemanager/dashboard">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
              <span className="nav-text">Case Dashboard</span>
            </NavLink>
          </li>
          {PERMISSIONS && PERMISSIONS.includes("clients_list") && (
            <li>
              <NavLink
                className="prepend-icon cbutton"
                to="/app/casemanager/client/list"
              >
                <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
                <span className="nav-text">Clients List</span>
              </NavLink>
            </li>
          )}
          {PERMISSIONS && PERMISSIONS.includes("profile_settings") && (
            <li>
              <NavLink to="/app/casemanager/profile/add">
                <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
                <span className="nav-text">Profile Settings </span>
              </NavLink>
            </li>
          )}
          {PERMISSIONS && PERMISSIONS.includes("change_password") && (
            <li>
              <NavLink to="/app/casemanager/change-password/add">
                <i className="zmdi zmdi-settings zmdi-hc-fw" />
                <span className="nav-text">Change Password </span>
              </NavLink>
            </li>
          )}
        </ul>
      ) : role == "lawfirm-manager" ? (
        <ul className="nav-menu">
          <li>
            <NavLink to="/app/lawfirm-manager/dashboard/">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
              <span className="nav-text">Manager Dashboard</span>
            </NavLink>
          </li>
          {PERMISSIONS && PERMISSIONS.includes("clients_list") && (
            <li>
              <NavLink
                className="prepend-icon cbutton"
                to="/app/manager/list"
              >
                <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
                <span className="nav-text">Clients</span>
              </NavLink>
            </li>
          )}
          {/*
          <li className="menu collapse-box">
            <Button href="javascript:void(0)" className="cbutton">
              <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
              <span className="nav-text">Clients</span>
            </Button>
            <ul className="sub-menu">
              <li>
                <NavLink
                  className="prepend-icon cbutton"
                  to="/app/manager/add"
                >

                  <span className="nav-text">Add Client </span>
                </NavLink>
              </li> 
              <li>
                <NavLink
                  className="prepend-icon cbutton"
                  to="/app/manager/list"
                >

                  <span className="nav-text">Clients List</span>
                </NavLink>
              </li>

            </ul>
          </li>
*/}

          {/* <li>
            <NavLink
              className="prepend-icon cbutton"
              to="/app/lawfirm-manager/client/list"
            >
              <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
              <span className="nav-text">Clients List</span>
            </NavLink>
          </li> */}
          {PERMISSIONS && PERMISSIONS.includes("notification") && (
            <li>
              <NavLink
                className="prepend-icon cbutton"
                to="/app/lawfirm-manager/notification"
              >
                <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
                <span className="nav-text">Notification</span>
              </NavLink>
            </li>
          )}
          {PERMISSIONS && PERMISSIONS.includes("profile_settings") && (
            <li>
              <NavLink to="/app/lawfirm-manager/profile/add">
                <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
                <span className="nav-text">Profile Settings </span>
              </NavLink>
            </li>
          )}
          {PERMISSIONS && PERMISSIONS.includes("change_password") && (
            <li>
              <NavLink to="/app/lawfirm-manager/change-password/add">
                <i className="zmdi zmdi-settings zmdi-hc-fw" />
                <span className="nav-text">Change Password </span>
              </NavLink>
            </li>
          )}
        </ul>
      ) : (
        <ul className="nav-menu">
          <li>
            <NavLink to="/app/party/dashboard">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
              <span className="nav-text">Dashboard</span>
            </NavLink>
          </li>
          {/* {PERMISSIONS && PERMISSIONS.includes("change_password") && ( */}
          <li>
            <NavLink to="/app/party/change-password">
              <i className="zmdi zmdi-edit" />
              <span className="nav-text">Change Password</span>
            </NavLink>
          </li>
          {/* )} */}
          {/* {PERMISSIONS && PERMISSIONS.includes("join_meeting") && ( */}
          <li>
            <NavLink to="/app/party/join-meeting">
              <i className="zmdi zmdi-videocam" style={{ color: "#007eff" }} />
              <span className="nav-text" style={{ color: "#007eff" }}>
                Join Meeting
              </span>
            </NavLink>
          </li>
          {/* )} */}
          {/* {PERMISSIONS && PERMISSIONS.includes("arbitration_cases") && ( */}
          <li className="menu collapse-box">
            <Button href="javascript:void(0)" className="cbutton">
              <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
              <span className="nav-text">Arbitration</span>
            </Button>
            <ul className="sub-menu">
              {/* <li>
                <NavLink
                  className="prepend-icon cbutton"
                  to="/app/party/register-case"
                >
                  <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
                  <span className="nav-text">File Fresh Case </span>
                </NavLink>
              </li> */}
              {/* {PERMISSIONS && PERMISSIONS.includes("filed_cases") && ( */}
              <li>
                <NavLink
                  className="prepend-icon cbutton"
                  to="/app/party/registered-cases"
                >
                  {/* <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" /> */}
                  <span className="nav-text">Filed Cases </span>
                </NavLink>
              </li>
              {/* )}
                {PERMISSIONS && PERMISSIONS.includes("respondent_cases") && ( */}
              <li>
                <NavLink
                  className="prepend-icon cbutton"
                  to="/app/party/all-respondant-cases"
                >
                  {/* <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" /> */}
                  <span className="nav-text">Respondent Cases</span>
                </NavLink>
              </li>
              {/* )} */}
            </ul>
          </li>
          {/* )} */}
          {/* {PERMISSIONS && PERMISSIONS.includes("mediation") && ( */}
          <li className="menu collapse-box">
            <Button href="javascript:void(0)" className="cbutton">
              <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
              <span className="nav-text">Mediation</span>
            </Button>
            <ul className="sub-menu">
              {/* <li>
                <NavLink
                  className="prepend-icon cbutton"
                  to="/app/party/mediation/file/fresh-case"
                >
                  <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
                  <span className="nav-text">File Fresh Case </span>
                </NavLink>
              </li> */}
              {/* {PERMISSIONS && PERMISSIONS.includes("filed_cases") && ( */}
              <li>
                <NavLink
                  className="prepend-icon cbutton"
                  to="/app/party/mediation/filed-cases"
                >
                  {/* <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" /> */}
                  <span className="nav-text">Filed Cases </span>
                </NavLink>
              </li>
              {/* )}
                {PERMISSIONS && PERMISSIONS.includes("second_party_cases") && ( */}
              <li>
                <NavLink
                  className="prepend-icon cbutton"
                  to="/app/party/mediation/second-party-cases"
                >
                  {/* <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" /> */}
                  <span className="nav-text">Second Party Cases </span>
                </NavLink>
              </li>
              {/* )} */}
            </ul>
          </li>
          {/* )} */}
          {/* {PERMISSIONS && PERMISSIONS.includes("conciliation") && ( */}
          <li className="menu collapse-box">
            <Button href="javascript:void(0)" className="cbutton">
              <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
              <span className="nav-text">Conciliation</span>
            </Button>
            <ul className="sub-menu">
              {/* <li>
                <NavLink
                  className="prepend-icon cbutton"
                  to="/app/party/conciliation/file/fresh-case"
                >
                  <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
                  <span className="nav-text">File Fresh Case </span>
                </NavLink>
              </li> */}
              {/* {PERMISSIONS && PERMISSIONS.includes("filed_cases") && ( */}
              <li>
                <NavLink
                  className="prepend-icon cbutton"
                  to="/app/party/conciliation/filed-cases"
                >
                  {/* <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" /> */}
                  <span className="nav-text">Filed Cases </span>
                </NavLink>
              </li>
              {/* )} */}
              {/* {PERMISSIONS && PERMISSIONS.includes("second_party_cases") && ( */}
              <li>
                <NavLink
                  className="prepend-icon cbutton"
                  to="/app/party/conciliation/second-party-cases"
                >
                  {/* <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" /> */}
                  <span className="nav-text">Second Party Cases </span>
                </NavLink>
              </li>
              {/* )} */}
            </ul>
          </li>
          {/* )} */}
          {/* <li>
            <NavLink to="/app/lawfirm/signature">
              <i className="zmdi zmdi-border-color" />
              <span className="nav-text">Sign Digitally</span>
            </NavLink>
          </li> */}
          {/* {PERMISSIONS && PERMISSIONS.includes("bookings") && ( */}
          <li>
            <NavLink to="/app/party/bookings">
              <i className="zmdi zmdi-settings zmdi-hc-fw" />
              <span className="nav-text">Bookings </span>
            </NavLink>
          </li>
          {/* )}
          {PERMISSIONS && PERMISSIONS.includes("profile_settings") && ( */}
          <li>
            <NavLink to="/app/party/change-password">
              <i className="zmdi zmdi-settings zmdi-hc-fw" />
              <span className="nav-text">Profile Settings </span>
            </NavLink>
          </li>
          {/* )} */}
        </ul>
      )}
    </div>
  );
};